import { cn } from '@pesto/utils';

import { Card, CardContent } from './Card';
import { LoadingSpinner } from './LoadingSpinner';

interface LoadingCardProps {
  className?: string;
  size?: number;
}

export const LoadingCard = ({ className, size }: LoadingCardProps) => (
  <Card className={className}>
    <CardContent className={cn('flex items-center justify-center py-12')}>
      <LoadingSpinner size={size} />
    </CardContent>
  </Card>
);
